﻿$(function () {
    var $topNAvigation = $('header .mdl-layout__header-row nav,.aga-l-nav');
    _setHamburberMenu($topNAvigation);
    $(window).resize(function () { _setHamburberMenu($topNAvigation); });
});

function _setHamburberMenu($this) {
    $this.removeAttr('data-menu-count');
    $this.find('ul li.more').css('display', 'inline-block');
    var _availableWidth = $this.outerWidth();
    var _computedWidth = 0, _nodeCount = 0;
    $this.children('ul').children('li:not(.more)').each(function () {
        var $self = $(this);
        _computedWidth += $self.outerWidth();
        if (_computedWidth > (_availableWidth - $this.find('ul li.more').outerWidth())) {
            $this.attr('data-menu-count', _nodeCount);
            return;
        }
        _nodeCount++;
    });
    if (_nodeCount >= ($this.children('ul').children('li:not(.more)').length)) $this.find('ul li.more').hide();

}